<template>
  <v-data-table :headers="headers" :items="filteredSurgeryTypes" sort-by="name">
    <template v-slot:top>
      <v-toolbar flat>
        <v-text-field
          label="Busca"
          v-model="filter"
          outlined
          dense
          hide-details
          clearable
          append-icon="eva-search-outline"
        />

        <v-spacer></v-spacer>

        <v-dialog v-model="dialog" fullscreen @click:outside="close">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="light-blue" dark v-bind="attrs" v-on="on">
              Nova descrição cirurgica
            </v-btn>
          </template>

          <v-card>
            <v-toolbar dark color="primary">
              <v-btn icon dark @click="close">
                <v-icon>mdi-close</v-icon>
              </v-btn>

              <v-toolbar-title>{{ formTitle }}</v-toolbar-title>

              <v-spacer />

              <v-toolbar-items>
                <v-btn dark text @click="save"> Salvar </v-btn>
              </v-toolbar-items>
            </v-toolbar>

            <v-container fluid>
              <v-row dense>
                <v-col cols="5">
                  <v-text-field
                    outlined
                    dense
                    hide-details
                    v-model="editedItem.name"
                    label="Nome"
                  />
                </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  <TemplateList
                    v-if="editedItem.id"
                    :surgeryIntraoperativeSurgery="editedItem"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>

    <template v-slot:item.actions="{ item }">
      <authorization
        permissionKey="configuration_surgery"
        can="save"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small class="mr-2" @click="editItem(item)">
          eva-edit-outline
        </v-icon>
      </authorization>

      <authorization
        permissionKey="configuration_surgery"
        can="delete"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small @click="deleteItem(item)">
          eva-trash-outline
        </v-icon>
      </authorization>
    </template>

    <template v-slot:no-data>
      <v-alert color="orange" outlined text type="info">
        Não há descrição cirurgicas cadastradas
      </v-alert>
    </template>
  </v-data-table>
</template>

<script>
import TemplateList from "@/components/config/surgery/surgery/template/list.vue";

export default {
  name: "SurgeryDescriptionConfig",
  components: {
    TemplateList,
  },
  apollo: {
    surgeryIntraoperativeSurgeries: {
      query: require("@/graphql/surgery/surgery_intraoperative_surgeries.gql"),
      pollInterval: 20000,
    },
  },
  data() {
    return {
      dialog: null,
      editedItem: {},
      editedIndex: -1,
      filter: "",
      headers: [
        { text: "Nome", value: "name" },
        { text: "Ações", value: "actions", sortable: false, align: "end" },
      ],
    };
  },
  computed: {
    filteredSurgeryTypes() {
      let surgeryIntraoperativeSurgeries = this.surgeryIntraoperativeSurgeries;

      if (this.filter) {
        surgeryIntraoperativeSurgeries = this.lodash.filter(
          surgeryIntraoperativeSurgeries,
          function (e) {
            return e.name
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .includes(
                this.filter
                  .toLowerCase()
                  .normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "")
              );
          }.bind(this)
        );
      }

      return surgeryIntraoperativeSurgeries;
    },
    formTitle() {
      return this.editedIndex === -1
        ? "Nova descrição cirurgica"
        : "Editar descrição cirurgica";
    },
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.filteredSurgeryTypes.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      if (confirm("Você realmente deseja deletar esse descrição cirurgica?")) {
        this.apolloMutate({
          mutation: require("@/graphql/surgery/delete_surgery_intraoperative_surgery.gql"),
          variables: {
            surgeryIntraoperativeSurgeryId: item.id,
          },
        }).then(() => {
          this.refreshList();

          this.$store.dispatch("createNotification", {
            message: "Descrição cirurgica deletado com sucesso.",
            type: "success",
          });
        });
      }
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    save() {
      this.apolloMutate({
        mutation: require("@/graphql/surgery/save_surgery_intraoperative_surgery.gql"),
        variables: {
          surgeryIntraoperativeSurgeryId: this.lodash.get(
            this.editedItem,
            "id",
            ""
          ),
          name: this.editedItem.name,
        },
      }).then(() => {
        this.refreshList();

        this.$store.dispatch("createNotification", {
          message: "Cadastro salvo com sucesso.",
          type: "success",
        });
      });

      this.close();
    },
    refreshList() {
      return this.$apollo.queries.surgeryIntraoperativeSurgeries.refetch();
    },
  },
};
</script>

<style lang="scss" scoped></style>
